/*
 * @Description: Do not edit
 * @Author: Do not edit
 * @Date: 2019-10-30 15:42:29
 * @LastEditTime: 2020-03-05 17:41:47
 * @LastEditors: cc
 */
/**
 * description: 微博直接签发-审核意见弹窗
 * author: Qian.qianchen 2018-11-20
 */
'use strict';
angular.module('weiboDirectSignModule', []).controller('weiboDirectSignCtrl', [
    '$scope',
    '$state',
    '$modalInstance',
    'itemArr',
    'trsHttpService',
    '$validation',
    'sensitiveWordCheckService',
    'flowStatus',
    'modalDialog',
    'isSave',
    '$q',
    'editcenterRightsService',
    'editingCenterWeiBoService',
    'weiboApiService',
    'weiboApiParams',
    'editingCenterService',
    function(
        $scope,
        $state,
        $modalInstance,
        itemArr,
        trsHttpService,
        $validation,
        sensitiveWordCheckService,
        flowStatus,
        modalDialog,
        isSave,
        $q,
        editcenterRightsService,
        editingCenterWeiBoService,
        weiboApiService,
        weiboApiParams,
        editingCenterService
    ) {
        initStatus();
        getZhenshenRight();

        /**
         * [initStatus description] 初始化状态
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.status = {
                params: {
                    ObjectIds: isSave
                        ? 0
                        : itemArr
                            .map(function(item) {
                                return item.SCMMICROCONTENTID;
                            })
                            .join(','),
                },
                isSave: isSave,
                channelId: angular.isDefined($state.params.wbchannelid) ? $state.params.wbchannelid : itemArr[0].PUBLISHACCOUNTIDS,
            };
            $scope.data = {
                auditContent: '',
            };
        }

        /**
         * [getZhenshenRight description] 获取政审权限
         * @return  {[type]}  [return description]
         */
        function getZhenshenRight() {
            editcenterRightsService.initWeiboListBtn('microblog.daishen', $scope.status.channelId).then(function(rights) {
                $scope.status.zhenshenRight = rights['microblog.daishen.zhengshen'];
            });
        }

        /**
         * [submitData 直接签发微博]
         *
         * @param   {[type]}  params  [params description]
         *
         * @return  {[type]}          [return description]
         */
        function submitData(params) {
            $scope.loadingPromise = weiboApiService.directSign(params, true).then(
                function(data) {
                    $modalInstance.close();
                },
                function(result) {
                    params.serviceid = 'wcm61_scmmicrocontent';
                    var options = {
                        params: params,
                        noAlert: true
                    };
                    editingCenterService.issuedByForce(result, options).then(function(result) {
                        if (result) {
                            $modalInstance.close();
                            return;
                        }
                        $modalInstance.dismiss();
                    });
                }
            );
        }

        /**
         * [sensitiveWordsCheck description] 敏感词校验
         * @param   {[string]}  content  [content description] 正文
         * @return  {[type]}             [return description]
         */
        function sensitiveWordsCheck(content) {
            var defer = $q.defer();
            if (typeof content === 'string') {
                sensitiveWordCheckService.getSensitiveWordOfContent(content).then(function(sensitiveWords) {
                    defer.resolve(sensitiveWords);
                });
            } else {
                editingCenterWeiBoService.hasSensitiveWords(content).then(function(sensitiveWords) {
                    defer.resolve(sensitiveWords);
                });
            }
            return defer.promise;
        }

        /**
         * [directSign description] 直接签发接口调用
         * @param  {[type]} docid [description]
         * @return {[type]}       [description]
         */
        function directSign(docid) {
            var content = '';
            let params = angular.extend({}, weiboApiParams.directSignParams, $scope.status.params);
            if (angular.isDefined(docid) && itemArr.length === 1) {
                params = docid;
                content = itemArr[0].Content;
            } else {
                content = itemArr;
            }
            if (flowStatus === '40') {
                params.methodname = 'processToPubOfDaiBianToJson';
            } else {
                params.methodname = 'processToPubOfDaiShenToJson';
            }
            params.content = $scope.data.auditContent;

            sensitiveWordsCheck(content).then(function(sensitiveWords) {
                if (sensitiveWords.length > 0) {
                    var tips = '';
                    if (itemArr.length === 1) {
                        tips =
                            '检测到ID为' +
                            sensitiveWords
                                .map(function(item) {
                                    return item.SCMMICROCONTENTID;
                                })
                                .join(',') +
                            '的稿件含有敏感词，是否继续签发？';
                    } else {
                        tips = '检测到敏感词，是否继续签发？';
                    }
                    modalDialog.alertType(
                        tips,
                        $scope.status.zhenshenRight ? '' : '注：如点击确定，稿件将等待敏感词审核完成之后才会正式签发。',
                        'warning',
                        true,
                        function() {
                            submitData();
                        },
                        function() {
                            $modalInstance.close({ info: 'error', result: { detail: '' } });
                        }
                    );
                } else {
                    submitData(params);
                }
            });
        }

        /**
         *  微博数据保存调用
         * @return {[type]} [description]
         */
        function saveWeibo() {
            var deferred = $q.defer();
            var params = angular.copy(itemArr[0]);
            params.objectId = 0;
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWeiboRootUrl(), params, 'post').then(function(docid) {
                deferred.resolve(JSON.parse(docid));
            });
            return deferred.promise;
        }

        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        /**
         * [confirm description] 表单信息提交-确认
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            $scope.auditForm.$pending = {};
            $validation.validate($scope.auditForm).success(function() {
                if ($scope.status.isSave) {
                    saveWeibo().then(function(docid) {
                        directSign(docid);
                    });
                } else {
                    directSign();
                }
            });
        };
    },
]);
